export default function getMemoFromByteString(memo: string) {
    // Never return the memo to the UI
    return null
}
